import  { Layout } from "react-grid-layout";
import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const ReactGridLayout = WidthProvider(RGL);


const WidgetBox: React.FC<{ page_layout: ReactGridLayout.Layout[], content:JSX.Element[]}> = ({ page_layout, content }) => {
  const onLayoutChange = (layout:Layout[])=>{
    
  }
  return (
    <ReactGridLayout useCSSTransforms={true}
        isDraggable={true}
        isResizable={true}
        autoSize={false}
        className="layout w-full h-full bg-white dark:bg-ngray"
        layout={page_layout}
        cols={12}
        rowHeight={30}
        width={1200}
        onLayoutChange={onLayoutChange}
    >
    {content}
    </ReactGridLayout>
    
  );
}
export default WidgetBox